import React, { useEffect, useContext } from 'react';
import { MapContext } from '@agissc/ktag-map';
import { MapBrowserEvent } from 'ol';
import useAppState from '../../AppStore';
import { FlyinNames } from '../../UIStateSlice';
import { ToolNames } from '../ToolNames';
import { useTracking } from '../../utils/tracking/TrackingContext';
import IdentifyCanvasOverlay from './IdentifyCanvasOverlay';

type SingleClickHandler = (e: MapBrowserEvent<PointerEvent>) => void;

const IdentifySpotlightOverlay = () => {
  const { map, view } = useContext(MapContext);
  const tolerance = useAppState((state) => state.tolerance);
  const activeFlyin = useAppState((state) => state.activeFlyin);
  const setActiveFlyin = useAppState((state) => state.setActiveFlyin);
  const activeTool = useAppState((state) => state.activeTool);
  const enabledIdentify = useAppState((state) => state.enabledIdentify);
  const identifyCoordinate = useAppState((state) => state.identifyCoordinate);
  const setIdentifyCoordinate = useAppState((state) => state.setIdentifyCoordinate);

  const { Tracking } = useTracking();

  const showSpotlight =
    enabledIdentify &&
    identifyCoordinate &&
    identifyCoordinate[0] !== 0 &&
    identifyCoordinate[1] !== 0 &&
    (activeFlyin === FlyinNames.Identify || activeTool === ToolNames.print);

  useEffect(() => {
    if (!enabledIdentify || !map || !view) return () => {};

    const handleClick: SingleClickHandler = (e) => {
      const { coordinate } = e;
      Tracking.Identify.clickMap(coordinate.toString());

      if (activeFlyin !== FlyinNames.Identify) {
        view.animate({
          center: coordinate,
          duration: 250,
        });
      }

      setActiveFlyin(FlyinNames.Identify);
      setIdentifyCoordinate(coordinate);
    };

    if (![ToolNames.draw, ToolNames.print].includes(activeTool)) {
      // @ts-expect-error OpenLayers 'singleclick' event handler typing issue with strict mode
      map.on('singleclick', handleClick);
    }

    return () => {
      // @ts-expect-error OpenLayers 'singleclick' event handler typing issue with strict mode
      map.un('singleclick', handleClick);
    };
  }, [
    map,
    view,
    enabledIdentify,
    activeTool,
    activeFlyin,
    setActiveFlyin,
    setIdentifyCoordinate,
    Tracking,
  ]);

  return (
    showSpotlight && (
      <IdentifyCanvasOverlay
        identifyCoordinate={identifyCoordinate}
        tolerance={tolerance}
      />
    )
  );
};

export default IdentifySpotlightOverlay;
